import * as configureSolarApi from '../store/configureSolarApi';
import * as requestTypes from '../store/requestTypes';

const einnahmenReducer = (state = {
    MixedBarDiagrammEinnahmenUI: [],
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_MixDiagrammEinnahmen_einnahmenReducer":
            return { ...state, MixedBarDiagrammEinnahmenUI: action.value, isLoaded: true };
        // Bei forceRefresh: Alte Daten sofort leeren damit Chart Skeleton zeigt!
        case requestTypes.requestStartType.type:
            return { ...state, MixedBarDiagrammEinnahmenUI: [], isLoaded: false };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default einnahmenReducer;
